<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[{ name: 'Email Alerts', to: { path: '/email-alerts' } }]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Email Alerts</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="createHandler">
        <v-icon class="pr-2 white--text">add</v-icon>
        <span>新增</span>
      </button>
    </div>
    <!--  -->
    <EmailAlertsTable class="mb-5"></EmailAlertsTable>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import EmailAlertsTable from '@/views/I-5__IR-EmailAlerts/c/EmailAlertsTable.vue';

export default {
  components: {
    BreadScrumbs,
    EmailAlertsTable,
  },
  created() {
    this.clear();
    this.getShareholderEmails();
  },
  methods: {
    ...mapActions('shareholderEmail', {
      getShareholderEmails: 'find',
      clear: 'clear',
    }),
    createHandler() {
      this.$router.push('/email-alerts/subscriber-create');
    },
    toEditPageTitle() {
      this.$router.push('/email-alerts/edit-email-alerts-page-title');
    },
  },
};
</script>

<style></style>
